import React from 'react';
import ReactDOM from 'react-dom/client';
import { Router } from 'wouter';
import { memoryLocation } from 'wouter/memory-location';
import { App } from './App.js';
import { platform } from './platform.js';
import { startAnalytics } from './analytics.js';
import { RateTablesProvider } from './rate-tables.js';
import { LocalDataGate } from './data-health.js';
import './styles/tokens.css';
import './styles/app.css';

document.documentElement.dataset.channel = platform.channel;
if (platform.channel === 'toss') document.documentElement.dataset.theme = 'light';
else {
  const storedTheme = window.localStorage.getItem('theme');
  if (storedTheme === 'dark' || (!storedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) document.documentElement.dataset.theme = 'dark';
}
const tossLocation = memoryLocation({ path: '/' });
const routerProps = platform.channel === 'toss' ? { hook: tossLocation.hook } : {};
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><Router {...routerProps}><LocalDataGate onReady={() => { void startAnalytics(); }}><RateTablesProvider><App /></RateTablesProvider></LocalDataGate></Router></React.StrictMode>);
